import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('arcade', {
  cherry: 'joystick',
  lemon: 'arcade_token',
  orange: 'pixel_heart',
  bell: 'jackpot_bell',
  star: 'arcade_cabinet_wild',
  seven: 'champion_trophy',
  gem: 'power_gem',
  scatter: 'coin_slot_scatter',
  money: 'token_jackpot',
});

/** Arcade — GENERATED by scaffoldSlot from
 *  content/slots/arcade.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const ARCADE_THEME: Theme = {
  id: 'arcade',
  name: 'Arcade',
  palette: {
    accent: 0xe0457b,
    secondary: 0xf08ab0,
    warm: 0xf2d27a,
    frameFill: 0x1c0e20,
    bgGradientTop: 0x3a1640,
    bgGradientBottom: 0x10060f,
    dimOverlay: 0x080309,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Joystick', glyph: '🕹️', tint: 0xc0392b, weight: 5, textureAlias: 'arcade:cherry',
        winVideoAlias: 'arcade:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Token', glyph: '🪙', tint: 0xe0c040, weight: 5, textureAlias: 'arcade:lemon',
        winVideoAlias: 'arcade:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Pixel Heart', glyph: '❤️', tint: 0xe04060, weight: 4, textureAlias: 'arcade:orange',
        winVideoAlias: 'arcade:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Score Bell', glyph: '🔔', tint: 0xd0c0c8, weight: 3, textureAlias: 'arcade:bell',
        winVideoAlias: 'arcade:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Arcade', glyph: '🕹️', tint: 0xe0457b, weight: 2, textureAlias: 'arcade:star',
        winVideoAlias: 'arcade:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Champion', glyph: '🏆', tint: 0xf0c040, weight: 2, textureAlias: 'arcade:seven',
        winVideoAlias: 'arcade:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Power Gem', glyph: '💎', tint: 0xe040a0, weight: 2.5, textureAlias: 'arcade:gem',
        winVideoAlias: 'arcade:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Insert Coin', glyph: '🎰', tint: 0xc0c0c8, weight: 0.5, textureAlias: 'arcade:scatter',
        winVideoAlias: 'arcade:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Token Bag', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'arcade:money',
        winVideoAlias: 'arcade:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1c0e20, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xe0457b, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xf08ab0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xe0457b, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1c0e20, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xf08ab0, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xe0457b, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'arcade:bg', path: 'environment/arcade.png' },
      columnBackground: { alias: 'arcade:column_bg', path: 'reel/arcade_column_bg.png' },
      border: { alias: 'arcade:border', path: 'brand/border_neon.png' },
    },
  },
};
